<div class="login-container">
  <div class="login-box">
    <!-- Tabs -->
    <div class="tabs">
      <button (click)="isLogin = true" [ngClass]="{ active: isLogin }" aria-label="Cambiar a iniciar sesión">
        Iniciar sesion
      </button>
      <button (click)="isLogin = false" [ngClass]="{ active: !isLogin }" aria-label="Cambiar a registrarse">
        Registrarse
      </button>
    </div>

    <!-- Avatar -->
    <div class="avatar">
      <img *ngIf="!isLogin; else defaultAvatar" src="../../../../assets/img/register.png" alt="User Avatar" />
      <ng-template #defaultAvatar>
        <img src="../../../../assets/img/usuario.png" alt="Default User Avatar" />
      </ng-template>
    </div>

    <!-- Título dinámico -->
    <h2>{{ isLogin ? "Iniciar sesion" : "Registrarse" }}</h2>

    <!-- Formulario de Login -->
    <form *ngIf="isLogin" [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()">
      <div class="input-group">
        <i class="fas fa-user"></i>
        <label for="login-email" class="sr-only">Correo electrónico</label>
        <input type="email" id="login-email" placeholder="Username or e-mail" formControlName="email" />
      </div>

      <div class="input-group">
        <i class="fas fa-lock"></i>
        <label for="login-password" class="sr-only">Contraseña</label>
        <input [type]="showPassword ? 'text' : 'password'" id="login-password" placeholder="Password"
          formControlName="password" />
        <i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'" (click)="showPassword = !showPassword"
          style="cursor: pointer; margin-left: -30px"
          [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"></i>
      </div>
      <!--
        <div *ngIf="errorMessage" class="error-message">
          <p>{{ errorMessage }}</p>
        </div> -->

      <button type="submit" class="btn-primary" [disabled]="loginForm.invalid || loading">
        Iniciar sesión
      </button>
      <div class="options">
        <label class="checkbox-container">
          <input type="checkbox" [(ngModel)]="rememberMe" name="rememberMe" [ngModelOptions]="{ standalone: true }" />
          <span class="checkmark"></span>
          Recordarme
        </label>
        <a (click)="openForgotPasswordModal()" aria-label="Abrir modal de recuperación de contraseña">Recuperar
          contraseña</a>
      </div>

      <!-- Modal de recuperación de contraseña -->
      <div class="modal" [class.show]="showModal">
        <div class="modal-content">
          <span class="close" (click)="closeForgotPasswordModal()"
            aria-label="Cerrar modal de recuperación de contraseña">&times;</span>
          <h2>Recuperar contraseña</h2>
          <p>Ingresa tu correo electrónico para restablecer tu contraseña.</p>
          <form (ngSubmit)="sendPasswordReset()">
            <label for="reset-email" class="sr-only">Correo electrónico para restablecer</label>
            <input name="resetEmail" type="email" id="reset-email" [(ngModel)]="resetEmail"
              placeholder="Correo electrónico" />
            <button type="submit" class="btn-primary" aria-label="Restablecer contraseña">Restablecer</button>
          </form>
        </div>
      </div>
      <p class="register-link">
        <a (click)="toggleForm()" aria-label="Ir a la página de registro">¿No tienes una cuenta?
          <strong>Registrarse</strong></a>
      </p>
    </form>

    <!-- Formulario de Registro -->
    <form *ngIf="!isLogin" [formGroup]="registerForm" (ngSubmit)="onRegisterSubmit()">
      <!-- Full Name -->
      <div class="input-group">
        <i class="fas fa-user"></i>
        <label for="register-name" class="sr-only">Nombre completo</label>
        <input type="text" id="register-name" placeholder="Full Name" formControlName="name" />
      </div>
      <div class="error-message" *ngIf="
          registerForm.get('name')?.touched && registerForm.get('name')?.invalid
        ">
        <span *ngIf="registerForm.get('name')?.errors?.required">El nombre es obligatorio.</span>
        <span *ngIf="registerForm.get('name')?.errors?.minlength">Debe tener al menos 3 caracteres.</span>
      </div>

      <!-- Email -->
      <div class="input-group">
        <i class="fas fa-envelope"></i>
        <label for="register-email" class="sr-only">Correo electrónico</label>
        <input type="email" id="register-email" placeholder="Email" formControlName="email" />
      </div>
      <div class="error-message" *ngIf="
          registerForm.get('email')?.touched &&
          registerForm.get('email')?.invalid
        ">
        <span *ngIf="registerForm.get('email')?.errors?.required">El correo es obligatorio.</span>
        <span *ngIf="registerForm.get('email')?.errors?.email">Correo inválido.</span>
      </div>

      <!-- Password -->
      <div class="input-group">
        <i class="fas fa-lock"></i>
        <label for="register-password" class="sr-only">Contraseña</label>
        <input [type]="showPassword ? 'text' : 'password'" id="register-password" placeholder="Password"
          formControlName="password" /><i class="fas" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
          (click)="showPassword = !showPassword" style="cursor: pointer; margin-left: -30px"
          [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"></i>
      </div>
      <div class="error-message" *ngIf="
          registerForm.get('password')?.touched &&
          registerForm.get('password')?.invalid
        ">
        <span *ngIf="registerForm.get('password')?.errors?.required">La contraseña es obligatoria.</span>
        <span *ngIf="registerForm.get('password')?.errors?.passwordInvalid">
          La contraseña debe tener al menos 8 caracteres, incluyendo letras y
          números.
        </span>
      </div>

      <!-- Confirm Password -->
      <div class="input-group">
        <i class="fas fa-lock"></i>
        <label for="register-confirm-password" class="sr-only">Confirmar contraseña</label>
        <input [type]="showConfirmPassword ? 'text' : 'password'" id="register-confirm-password"
          placeholder="Confirm Password" formControlName="confirmPassword" />
        <i class="fas" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"
          (click)="showConfirmPassword = !showConfirmPassword" style="cursor: pointer; margin-left: -30px"
          [attr.aria-label]="showConfirmPassword ? 'Ocultar confirmación de contraseña' : 'Mostrar confirmación de contraseña'"></i>
      </div>
      <div class="error-message" *ngIf="
          registerForm.get('confirmPassword')?.touched &&
          registerForm.get('confirmPassword')?.invalid
        ">
        <span *ngIf="registerForm.get('confirmPassword')?.errors?.required">Confirma tu contraseña.</span>
        <span *ngIf="registerForm.get('confirmPassword')?.errors?.mismatch">Las contraseñas no coinciden.</span>
      </div>

      <!-- Submit -->
      <button type="submit" class="btn-primary" [disabled]="loading" aria-label="Registrarse">
        Registrarse
      </button>

      <!-- Toggle to Login -->
      <p class="register-link">
        <a (click)="toggleForm()" aria-label="Ir a la página de inicio de sesión">¿Ya tienes una cuenta? <strong>Iniciar
            sesión</strong></a>
      </p>
    </form>
  </div>
</div>
<div class="notification success" *ngIf="showSuccessNotification">
  ✅ Registro exitoso
</div>
<div class="notification success" *ngIf="showChangeSuccessNotification">
  ✅ A su correo se envio la nueva contraseña.
</div>
<div *ngIf="loading" class="loading-overlay">
  <div class="loading-spinner"></div>
  <p>Cargando...</p>
</div>
<div *ngIf="showErrorModal" class="error-modal">
  <div class="error-modal-content">
    <span class="closeError" (click)="closeModal()">&times;</span>
    <h2>Error</h2>
    <p>{{ errorMessage }}</p>
  </div>
</div>